module.exports = __webpack_public_path__ + "static/media/jj.ca3931af.png";